import Link from 'next/link';

import type { FunctionComponent } from 'react';
import type { TypeTrendingSearchesProps } from './types';

/** Pills "Lo más buscado". Estilos asumen fondo oscuro (hero centered). */
export const TrendingSearches: FunctionComponent<TypeTrendingSearchesProps> = ({
  className = '',
  title,
  items,
}: TypeTrendingSearchesProps) => {
  if (!items?.length) return null;

  return (
    // Mobile: título arriba (su propia fila), chips juntos en flex-wrap
    // debajo — evita el "título + 1 chip / chip / chip" en 3 filas feo.
    // Desktop (md+): título y chips en una sola fila con wrap (vía
    // `md:contents` en el wrapper de chips, que desaparece como flex item
    // y deja a sus hijos como children directos del flex exterior).
    <div
      className={`flex w-full flex-col items-center gap-3 md:flex-row md:flex-wrap md:justify-center ${className}`}
    >
      {title && (
        <p className="text-body text-body-l text-neutrals-0 font-bold">
          {title}
        </p>
      )}

      {/* Mobile: contenedor `w-fit` se ajusta al chip más ancho; los chips
          son `flex` (no `inline-flex`) → flex-col por defecto los estira a
          la anchura del contenedor → todos iguales al más ancho. Desktop
          (md:contents) disuelve el wrapper y cada chip vuelve a anchura
          natural en el `flex-wrap` del padre. */}
      <div className="flex w-fit flex-col gap-2 md:contents">
        {items.map((item, index) => (
          <Link
            key={item.id ?? index}
            href={item.Link}
            prefetch={false}
            className="text-body text-neutrals-0 hover:bg-neutrals-0/10 border-neutrals-0 flex items-center justify-center rounded-full border px-4 py-1 text-center text-[14px] leading-[18px] transition-colors"
          >
            {item.Texto}
          </Link>
        ))}
      </div>
    </div>
  );
};

TrendingSearches.displayName = 'TrendingSearches';
